import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getSocialMedia,
  updateSocialMediaRequest,
} from "../../../../services/api/landing/socialMedia/socialMediaApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  update: {
    en: "Social media updated successfully!",
    ar: "تم تحديث وسائل التواصل الاجتماعي بنجاح!",
  },
  updateError: {
    en: "Failed to update social media.",
    ar: "فشل في تحديث وسائل التواصل الاجتماعي.",
  },
};

export const fetchSocialMedia = createAsyncThunk(
  "socialMedia/fetchSocialMedia",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSocialMedia();
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch social media");
    }
  },
);

export const updateSocialMedia = createAsyncThunk(
  "socialMedia/updateSocialMedia",
  async (socialMediaData, { rejectWithValue }) => {
    try {
      const response = await updateSocialMediaRequest(socialMediaData);
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to update social media");
    }
  },
);

const socialMediaSlice = createSlice({
  name: "socialMedia",
  initialState: {
    socialMediaData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSocialMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.socialMediaData = action.payload;
      })
      .addCase(fetchSocialMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSocialMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSocialMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.socialMediaData = action.payload;
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateSocialMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      });
  },
});

export default socialMediaSlice.reducer;
